// Stand-in for object-inspect's `./util.inspect`, which its package.json excludes from browser
// builds (`"browser": { "./util.inspect.js": false }`). See the `resolve.alias` entry in
// vite.config.ts for why Vite 8 needs help honouring that.
export default {};
